import { ICompanyAddress } from "@/api/AppApi/services/company/interfaces/ICompany";
import ContactUsSubtitle from "../ContactUsSubtitle";
import SvgContactAddress from "./SvgContactAddress";
import SiteGoogleMap from "@/app/components/lib/googlemaps/LazySiteGoogleMap";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  address: ICompanyAddress;
}

const ContactUsAddress: React.FC<Props> = ({ address }) => {
  const t = useTranslation();
  return (
    <div>
      <ContactUsSubtitle text={t.company_address} />
      <div className="contact-us-address">
        <div className="address-text">
          <SvgContactAddress />
          {address?.other_address}
        </div>
        {address?.location && (
          <div className="address-map">
            <SiteGoogleMap
              width="100%"
              height={240}
              position={address.location}
              setPosition={undefined}
              viewOnly
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUsAddress;
